export const createUpsellEvent = (label, featureName) => ({
  category: 'upsell',
  action: 'upsell_requested',
  label,
  feature_name: featureName || label,
});
